import { useFileOperations } from '@dev-streetbeat/chat';
import { DownloadIcon, ExpandIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from 'shared/components/ui/dialog';
import { useChatScrollToBottom } from '../../../chat/hooks';

import type { File } from '@dev-streetbeat/chat';

import styles from './ImageFileArtifact.module.scss';

type Props = {
  file: File;
};

export const ImageFileArtifact: React.FC<Props> = ({ file }) => {
  const [url, setUrl] = useState('');

  const { getFileUrl, downloadFile } = useFileOperations();
  const { scrollToBottom } = useChatScrollToBottom();

  useEffect(() => {
    getFileUrl(file.id).then(setUrl).catch(console.error);
  }, [file.id]);

  const download = async () => {
    try {
      const fileName = file.name;
      const fileId = file.id;
      const response = await downloadFile(fileId);

      const link = document.createElement('a');
      link.href = URL.createObjectURL(response);
      link.download = fileName;
      link.click();
    } catch (error) {
      console.error(error);
    }
  };

  const openDialog = async () => {
    // update url on click

    try {
      const url = await getFileUrl(file.id);
      setUrl(url);
    } catch (error) {
      console.error(error);
    }
  };

  const handleImageLoaded = () => {
    requestAnimationFrame(() => {
      scrollToBottom(true);
    });
  };

  if (!url) {
    return null;
  }

  return (
    <>
      <div className={styles.imageContainer}>
        <div className={styles.imageOverlayActions}>
          <div className={styles.overlayButton} onClick={download}>
            <DownloadIcon className="size-4" />
          </div>
          <Dialog>
            <DialogTrigger asChild>
              <div className={styles.overlayButton}>
                <ExpandIcon className="size-4" onClick={openDialog} />
              </div>
            </DialogTrigger>
            <DialogContent className={styles.dialogContent}>
              <DialogTitle className={styles.dialogTitle}>{file.name}</DialogTitle>
              <div className="mt-6">
                <img src={url} className="w-fit" alt={file.name} />
              </div>
            </DialogContent>
          </Dialog>
        </div>
        <img className={styles.imageContent} src={url} alt={file.name} onLoad={handleImageLoaded} />
      </div>
      <div id={file.id.toString()} className="image-attachment-scroll-margin"></div>
    </>
  );
};
